import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";

import Header from '../components/header';

function List( {item} ) {
  const { id } = useParams(); // ดึง id จาก URL parameter
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type"); // ดึง type จาก query string

  const [data, setData] = useState([]);
  const [status, setStatus] = useState(""); // สถานะของรายการ
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null); // เพิ่ม state สำหรับ user

  const [note, setNote] = useState('');  // ใช้ state สำหรับ note
  const [adminNote, setAdminNote] = useState('-');  // ค่าเริ่มต้นเป็น '-'

  useEffect(() => {
    setAdminNote(item?.list_admin || '-');  // ตรวจสอบ item.list_admin ว่ามีค่าหรือไม่
  }, [item]);  // ใช้ item เป็น dependency ใน useEffect

  useEffect(() => {
    if (!id) return;
  
    const fetchData = async () => {
      try {
        const domain = "software.piyamanee.com";
        const response = await fetch(`https://${domain}/server/fetch/dataList.php`);
        const newData = await response.json();
  
        console.log("API Response:", newData); // เช็คข้อมูลที่ API ส่งมา
        console.log("ID:", id);
  
        const filteredData = newData.filter((item) => item.list_id_type === id);
        console.log("Filtered Data:", filteredData);
  
        setData(filteredData);
  
        if (filteredData.length > 0) {
          setStatus(filteredData[0].list_status);
        } else {
          setStatus("");
        }
        
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, [id]);

  const handleSaveNote = async () => {
    const dataId = document.querySelector('.listNoteData').getAttribute('data-id');

    const formData = new FormData();
    formData.append('note', note);
    formData.append('list_id_type', dataId);

    try {
      // const domain = "localhost";
      const domain = "software.piyamanee.com";
      const response = await fetch(`https://${domain}/server/form/instAdmin.php`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.status === 'success') {
        setAdminNote(note);  // อัปเดต adminNote เมื่อการบันทึกสำเร็จ
        alert('หมายเหตุถูกบันทึกแล้ว');
      } else {
        alert('เกิดข้อผิดพลาดในการบันทึกหมายเหตุ');
      }
      
    } catch (error) {
      console.error('Error:', error);
      alert('เกิดข้อผิดพลาด');
    }
  };
  
  // ตรวจสอบและอัปเดต document.title ทุกครั้งที่ data เปลี่ยนแปลง
  useEffect(() => {
    if (data.length > 0) {
      document.title = `ดูรายการ: ${data[0].list_reason} - ${data[0].list_username}`;
    } else {
      document.title = "ดูรายการ";
    }
  }, [data]); // ใช้ data เป็น dependency ทุกครั้งที่ data เปลี่ยนแปลง

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error("Error parsing user data from localStorage", error);
        setUser(null);
      }
    } else {
      setUser(null);
    }
  }, []);

  const updateStatus = async (newStatus) => {
    if (loading) return; // ป้องกันการกดซ้ำ

    setLoading(true); // เริ่มโหลด

    try {
      // const domain = 'cdn.jobsallow.site';
      // const domain = 'software.piyamanee.com';
      const domain = "software.piyamanee.com";
      const response = await fetch(`https://${domain}/server/update/updateStatus.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: newStatus }),
      });

      const result = await response.json();
      if (result.success) {
        setStatus(newStatus); // ✅ อัปเดตสถานะใน State ทันที
      } else {
        alert("❌ อัปเดตไม่สำเร็จ: " + result.message);
      }
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ เกิดข้อผิดพลาดในการอัปเดต");
    } finally {
      setLoading(false); // ปิดโหลด
    }
  };

  if (data.length === 0) {
    return (
      <div style={{ color: "red", 
        textAlign: "center", 
        fontSize: "16px", 
        fontWeight: "bold", 
        marginTop: "50px", 
        backgroundColor: "#ff000008",
        padding: "20px",
        borderRadius: "10px" }}>
        <i className="fa-solid fa-trash"></i> รายการนี้ถูกลบไปแล้ว
      </div>
    );
  }

  return (
    <div>
      <Header />

      <div className='indexMain_ContentArea_Container'>
        <h4 style={{marginTop:"100px" , fontSize: "16px"}}>รายการข้อมูล</h4>

        {data.length > 0 ? (
            <div className='listDataBody'>
              {/* Start data */}
              {data.map((item) => (
                  <div key={item.id}>
                    
                    {user ? (
                                
                        <div className='listDataDropdownState desktop'>
                          <div className="dropdown">
                            <button className="btn btn-sm dropdown-toggle buttonSettings" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="fa-solid fa-gears"></i> สถานะ
                            </button>
                            <ul className="dropdown-menu dropdown-menu-dark dropdownContent">
                              <li>
                                <button className="dropdown-item" onClick={() => updateStatus('Success')}>
                                  <i className="fa-solid fa-circle-check"></i> สำเร็จ
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item" onClick={() => updateStatus('Processing')}>
                                  <i className="fa-solid fa-person-running"></i> กำลังดำเนินการ
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item" onClick={() => updateStatus('Cancel')}>
                                  <i className="fa-solid fa-ban"></i> ผู้แจ้งยกเลิกงาน
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                                
                      ) : (
                        <div></div>
                      )}

                    <div className='listDataPrint'>
                      <NavLink to="#" onClick={(e) => { e.preventDefault(); window.print(); }}>
                        <i className="fa-solid fa-print"></i> พิมพ์
                      </NavLink>
                    </div>

                    <div className='camp'>
                        <NavLink to='/repair'><i class="fa-solid fa-house"></i> แจ้งซ่อม</NavLink>
                        <span style={{margin: "0px 5px"}}> : </span>
                        <div style={{ maxWidth: "500px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          <NavLink to={`/repair/list/${item.list_id_type}?type=${item.list_type}`} title={item.list_reason}>
                            {item.list_reason}
                          </NavLink>
                        </div>
                    </div>

                    <div style={{display: "flex" , alignItems: "center"}} className='listOrderName'>
                        <div style={{marginBottom: "10px" , fontSize: "13px" , marginRight: "10px"}} className='listOrderNameFirst'> 
                            <span style={{fontWeight: "300"}}> ลำดับ : </span> <span style={{marginLeft: "5px"}}>{item.list_index}</span> 
                        </div>
                        <div style={{marginBottom: "10px" , fontSize: "13px"}}> 
                            <span style={{fontWeight: "300"}}> เลขที่ใบงาน : </span> <span style={{marginLeft: "5px"}}>{item.list_id_type}</span> 
                        </div>
                     </div>

                    <div className='listGridContainer'>
                      <div className='listDataBoxContent'>
                          <i class="fa-solid fa-user"></i> <span style={{marginLeft: "5px"}}> {item.list_username}</span>
                      </div>
                      
                      <div className='listDataBoxContent'>
                        <div style={{marginRight: "5px" , fontSize: "13px"}}> แจ้งสำหรับ </div>
                        <div>
                          {(() => {
                                    const listType = Number(item.list_type);

                                    if (isNaN(listType)) {
                                      return <span>-</span>; 
                                    }

                                    switch (listType) {
                                      case 1:
                                        return <div className="alertLabelForType"><i class="fa-solid fa-gear"></i> งานช่าง</div>;
                                      case 2:
                                        return <div className="alertLabelForType"><i class="fa-brands fa-instalod"></i> IT Support</div>;
                                      case 3:
                                        return <div className="alertLabelForType"><i class="fa-brands fa-instalod"></i> Programmer</div>;
                                      default:
                                        return <div className="alertLabelForType"><i class="fa-solid fa-user-slash"></i> ไม่ทราบประเภทงาน</div>;
                                    }
                          })()}
                        </div>
                      </div>
                      <div className='listDataBoxContent'> 
                          <i class="fa-solid fa-clock"></i> <span style={{marginLeft: "5px" , fontSize: "13px"}}> วันที่แจ้ง :  </span> <span style={{marginLeft: "5px" , fontSize: "13px"}}>{item.list_date_real}</span> 
                      </div>
                      <div 
                        className='listDataBoxContent' 
                        style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}
                      >
                        <i className="fa-solid fa-building"></i> 
                        <span style={{ marginLeft: "5px" , fontSize: "13px"}}>สังกัด:</span> 
                        <span style={{ marginLeft: "5px" , fontSize: "13px" }}>{item.list_company}</span>
                      </div>
                      <div className='listDataBoxContent'> 
                          <i class="fa-solid fa-building"></i> <span style={{marginLeft: "5px"}}> แผนก :  </span> <span style={{marginLeft: "5px"}}>{item.list_department}</span> 
                      </div>
                      <div className='listDataBoxContent'> 
                          <i class="fa-solid fa-building"></i> <span style={{marginLeft: "5px"}}> ตำแหน่ง :  </span> <span style={{marginLeft: "5px"}}>{item.list_position}</span> 
                      </div>
                    </div>
                    <div style={{marginTop: "25px"}}>
                      {/* <div style={{marginBottom: "10px"}}> รายละเอียด </div> */}

                      <div>
                        <i class="fa-solid fa-server"></i> เรื่องที่แจ้ง :
                        <div style={{color: "gray" , fontSize: "14px" , marginTop: "5px"}} className='descFonts'> <span> {item.list_reason} </span> </div>
                      </div>

                      <div style={{marginLeft : "0px" , marginTop: "10px"}}>
                        <div><i class="fa-solid fa-phone"></i> เบอร์โทรศัพท์ : </div>
                        <div style={{color: "gray" , fontSize: "14px" , marginTop: "5px"}} className='descFonts'> {item.list_phone} </div>
                      </div>

                      <div style={{marginLeft : "0px" , marginTop: "10px"}}>
                        <div><i class="fa-solid fa-circle-info"></i> หมายเหตุ : </div>
                        <div style={{color: "gray" , fontSize: "14px" , marginTop: "5px"}} className='descFonts'> {item.list_admin || '-'} </div>
                      </div>

                      {user ? (
                                
                        <div style={{ marginLeft: "0px", marginTop: "10px" }} className="adminNote">
                          <div style={{ fontWeight: "500", marginBottom: "6px" }}>
                            รายละเอียดการซ่อมงาน :
                          </div>

                          <div
                            className="descFonts"
                            style={{
                              color: "gray",
                              fontSize: "14px",
                              marginTop: "5px",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                              flexWrap: "wrap"
                            }}
                          >
                            <textarea
                              data-id={item.list_id_type}
                              className="form-control listNoteData"
                              placeholder="กรอกรายละเอียดการซ่อมงาน..."
                              value={note}
                              name="listDataAdminNote"
                              rows={4}
                              onChange={(e) => setNote(e.target.value)}
                              style={{
                                minHeight: "120px",
                                resize: "vertical",
                                width: "100%",
                                maxWidth: "700px",
                                fontSize: "15px",
                                lineHeight: "1.6",
                                padding: "12px",
                                borderRadius: "10px"
                              }}
                            />

                            <button
                              className="btn btn-primary"
                              onClick={handleSaveNote}
                              style={{
                                fontSize: "14px",
                                minWidth: "120px",
                                height: "44px",
                                borderRadius: "10px",
                                whiteSpace: "nowrap"
                              }}
                            >
                              <i className="fa-solid fa-circle-check"></i> บันทึก
                            </button>
                          </div>
                        </div>
                                        
                      ) : (
                        <div></div>
                      )}

                      {(() => {
                        switch (status) {
                          case "Waiting":
                            return (
                              <div
                                className="alertLabelForStatus"
                                style={{
                                  background: "rgb(255 165 0 / 13%)",
                                  color: "orange",
                                  marginTop: "10px",
                                  fontSize: "15px",
                                }}
                              >
                                <i className="fa-solid fa-hourglass-start"></i> กำลังรอ
                              </div>
                            );
                          case "Processing":
                            return (
                              <div
                                className="alertLabelForStatus"
                                style={{
                                  background: "rgb(77 131 163 / 13%)",
                                  color: "#6c91e3",
                                  marginTop: "10px",
                                  fontSize: "15px",
                                }}
                              >
                                <i className="fa-solid fa-person-running"></i> กำลังดำเนินการ
                              </div>
                            );
                          case "Success":
                            return (
                              <div
                                className="alertLabelForStatus"
                                style={{
                                  background: "rgb(77 163 100 / 13%)",
                                  color: "rgb(42 151 55)",
                                  marginTop: "10px",
                                  fontSize: "15px",
                                }}
                              >
                                <i className="fa-solid fa-circle-check"></i> เรียบร้อยแล้ว
                              </div>
                            );
                          case "Cancel":
                            return (
                              <div
                                className="alertLabelForStatus"
                                style={{
                                  background: "rgb(163 77 77 / 13%)",
                                  color: "rgb(237 29 29)",
                                  marginTop: "10px",
                                  fontSize: "15px",
                                }}
                              >
                                <i class="fa-solid fa-ban"></i> ยกเลิก
                              </div>
                            );
                          default:
                            return (
                              <div className="alertLabelForStatus">
                                <i className="fa-solid fa-user-slash"></i> ไม่ทราบประเภทงาน
                              </div>
                            );
                        }
                      })()}

                    </div>
                    {/* img */}
                    <div className='listDataImgContainer'>
                        {item.list_img ? (
                          <div style={{ textAlign: "center" }}>
                            {/* FancyBox link for enlarging the image */}
                            <a
                              href={`https://software.piyamanee.com/uploads/${item.list_img}`} // Link to the full-sized image
                              data-fancybox="gallery" // Enable FancyBox gallery functionality
                              data-caption={item.list_reason} // Optional: caption for the image (if needed)
                            >
                              <img
                                src={`https://software.piyamanee.com/uploads/${item.list_img}`}
                                alt="รูปภาพ"
                                fetchPriority="high"
                                className="listDataImgClass"
                                style={{
                                  maxWidth: "50%", // Optional: set the max width
                                  cursor: "pointer", // Pointer cursor to indicate it's clickable
                                }}
                              />
                            </a>
                          </div>
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <span style={{ color: "gray" , fontSize: "14px" }}>
                              <i className="fa-solid fa-circle-info"></i> ไม่ได้แนบรูปภาพ
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
              ))}
              {/* End data */}
            </div>
        ) : (
            <p>กำลังโหลดข้อมูล...</p>
        )}

      </div>

    </div>
  );
}

export default List;